import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const UpsellWellnessBundle = lazyWithPreload(
  () => import('./UpsellWellnessBundle'),
)
